<template>
    <div class="d-flex justify-content-between card-module-header" @click="toggleCollapse">
        <span> {{ $t(`profile.tabs.${moduleName}`) }} </span>
        <span class="arrow-color">
            <i :class="['fas fa-md', state ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        state: {
            type: Boolean,
            required: true,
        },
        module: {
            type: String,
            required: true,
        },
    },
    methods: {
        toggleCollapse() {
            this.$emit('onToggleCollapse', !this.state)
        },
    },
    computed: {
        moduleName() {
            return this.module === 'myInitiatives' ? 'initiatives' : this.module
        },
    },
}
</script>

<style lang="sass" scoped>
.arrow-color
    color: #009ADA;
    &:hover
        color: #007BAE;
.card-module-header
    padding: 0.75rem 1.25rem
    cursor: pointer
</style>
